var _ellipse, _rect, _rect2, _ellipse2, _ellipse3, _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayUserLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 85,
    viewBox: "0 0 112 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.9733,
    cy: 49.2127,
    rx: 34.0092,
    ry: 31.8836,
    fill: "#EBEBEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.9734,
    y: 15.9595,
    width: 20.6314,
    height: 14.879,
    rx: 2,
    transform: "rotate(-30.018 34.9734 15.9595)",
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0386,
    y: 0.324219,
    width: 20.6314,
    height: 14.879,
    rx: 2,
    transform: "rotate(52.5921 34.0386 0.324219)",
    fill: "#EBEBEB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3117,
    cy: 38.5846,
    rx: 1.59418,
    ry: 2.12558,
    fill: "#9C9C9C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.8142,
    cy: 39.6471,
    rx: 1.59418,
    ry: 2.12558,
    fill: "#9C9C9C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_714_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5195 48.0015L89.3966 47.3537C95.8518 47.2225 101.191 52.3491 101.322 58.8044C101.454 65.2596 96.3269 70.599 89.8716 70.7302L81.3711 70.9029C68.4606 71.1653 57.7819 60.912 57.5195 48.0015Z",
    fill: "#F6F6F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_714_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9778 48.4302L72.6047 24.1177C76.7818 19.1943 84.1591 18.5893 89.0825 22.7664C94.0059 26.9434 94.6109 34.3208 90.4339 39.2442L84.9333 45.7275C76.5792 55.5742 61.8245 56.7843 51.9778 48.4302Z",
    fill: "#F6F6F6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0726 48.9435C10.6344 49.0761 10.3843 49.5399 10.5429 49.9694C11.0744 51.4082 11.8424 52.7503 12.817 53.9397C13.9671 55.343 15.3822 56.5061 16.9818 57.3625C18.5813 58.219 20.3338 58.752 22.1393 58.9311C23.9449 59.1102 25.768 58.932 27.5046 58.4065C29.2412 57.8811 30.8573 57.0187 32.2607 55.8687C33.664 54.7186 34.8271 53.3035 35.6836 51.7039C36.54 50.1044 37.073 48.3519 37.2521 46.5464C37.4039 45.0162 37.299 43.4734 36.9437 41.9813C36.8376 41.5359 36.3723 41.2886 35.9341 41.4212C35.4959 41.5538 35.251 42.0161 35.3535 42.4623C35.6479 43.7452 35.7326 45.0692 35.6022 46.3827C35.4446 47.9715 34.9756 49.5138 34.2219 50.9213C33.4683 52.3289 32.4448 53.5743 31.2098 54.5863C29.9749 55.5983 28.5527 56.3572 27.0244 56.8196C25.4962 57.282 23.8919 57.4389 22.303 57.2812C20.7142 57.1236 19.1719 56.6546 17.7644 55.9009C16.3568 55.1473 15.1114 54.1237 14.0994 52.8888C13.2628 51.8679 12.5992 50.719 12.133 49.4881C11.9709 49.0599 11.5108 48.8109 11.0726 48.9435Z",
    fill: "#9C9C9C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_714_1571",
    x: 47.5195,
    y: 41.3511,
    width: 63.8052,
    height: 43.5566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_1571",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_714_1571",
    x: 41.9778,
    y: 13.9902,
    width: 61.2324,
    height: 53.9927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1571"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_1571",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayUserLevel3);
export default __webpack_public_path__ + "static/media/grayUserLevel3.14b97296101ccc5a157e4b6fc881a237.svg";
export { ForwardRef as ReactComponent };